import type { TimeWindow } from '@/types';

import { request } from './client';

export interface TradeRecord {
  avg_price?: number | null;
  close?: number | null;
  high?: number | null;
  low?: number | null;
  open?: number | null;
  time?: string;
  volume?: number | null;
}

export interface TradesResponse {
  trades: TradeRecord[];
  timeWindow?: TimeWindow;
}

export interface FetchTradesParams {
  symbol: string;
  timeWindow: TimeWindow;
  from?: number;
  to?: number;
  signal?: AbortSignal;
}

export function fetchTrades({
  symbol,
  timeWindow,
  from,
  to,
  signal,
}: FetchTradesParams) {
  return request<TradesResponse>({
    path: `/api/trades/${encodeURIComponent(symbol)}`,
    query: {
      timeWindow,
      from,
      to,
      _t: Date.now(),
    },
    signal,
  });
}
